var fsApiKey = '32b865a69e92dd04c10786593beef991';
const inflateSubcollections = async (subCollectionIds) => {
    //Retrieve the collection info and pictures for each subCollectionIDs
    for (let i = 0; i < subCollectionIds.length; i++) {
        let response = await fetch(`https://kave-home-singapore.myshopify.com/api/2024-04/graphql.json`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': fsApiKey,
            },
            body: JSON.stringify({
                query: `query getCollectionById($id: ID!) {
                    collection(id: $id) {
                        handle
                        title
                        image {
                            altText
                            originalSrc
                            }
                    }
                }`,
                variables: {
                    id: subCollectionIds[i]
                }
            })
        })
            .then(response => response.json())
            .then(response => {
                let cleanId = subCollectionIds[i].replace('gid://shopify/Collection/', '');
                let collectionLi = document.querySelector('#subcollection-' + cleanId);
                collectionLi.innerHTML = `
                
                <a href="/collections/${response.data.collection.handle}">
                    <div class="subcollection-image">
                        <div class="subcollection-image-inner" style="background-image: url('${response.data.collection.image != null ?  response.data.collection.image.originalSrc : ''}');" alt="${response.data.collection.image != null ? response.data.collection.image != null : ''}">
                    </div>`;

                collectionLi.innerHTML += `
                    <div class="subcollection-title">
                        <label>${response.data.collection.title}</label>
                    </div>
                </a>
                `;
            });
    }
};

/**
 * This script manages the subcollections of the storefront
 */
const bootstrapSubcollections = async () => {
    let container = document.querySelector('#collection-subcollections');
    if (container == null || typeof container == 'undefined') {
        window.setTimeout(bootstrapSubcollections, 350);
        return;
    }

    // Get the collection ID
    let collectionId = container.getAttribute('data-collection-id');
    //get the collection object
    let response = await fetch(`https://kave-home-singapore.myshopify.com/api/2024-04/graphql.json`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': fsApiKey,
        },
        body: JSON.stringify({
            query: `query getCollectionById($id: ID!) {
            collection(id: $id) {
              title
              metafields: metafield(namespace: "custom", key: "subcolecciones") {
                  value
                  type
                }
            }
          }`,
            variables: {
                id: 'gid://shopify/Collection/' + collectionId
            }
        })
    })
        .then(response => response.json())
        .then(response => {
            if(response.data.collection == null) {
                return;
            }
            if(response.data.collection.metafields == null) {
                return;
            }
            let subCollectionIds = JSON.parse(response.data.collection.metafields.value);

            //For-each create an empty div
            for (let i = 0; i < subCollectionIds.length; i++) {
                let div = document.createElement('div');
                div.setAttribute('id', 'subcollection-' + subCollectionIds[i].replace('gid://shopify/Collection/', ''));
                div.setAttribute('data-subcollection-id', subCollectionIds[i]);
                div.setAttribute('class', 'subcollection');
                container.appendChild(div);
            }

            //Now, inflate the collections
            inflateSubcollections(subCollectionIds);
        });

};

bootstrapSubcollections();